import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Container,
  Divider,
  Grid,
  Paper,
  ToggleButtonGroup,
  ToggleButton,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";
import bannerImg from "../../assets/images/home/banner-image.svg";
import planningImg from "../../assets/images/home/planning.svg";
import overview from "../../assets/images/home/overview.svg";
import file from "../../assets/images/home/file.svg";
import saveImg from "../../assets/images/home/save.svg";
import fileBrowser from "../../icons/file-browser.svg";
import Inbox from "../../components/home/Inbox";
// import Video from "../../components/Video";
import { getMyRequestSuccess } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import cssVariables from "../../theme/cssVariables";
import React, { useEffect } from "react";
import axios from "axios";
import { fetchHomeDashBoard } from "../../actions/home";
import { ReactComponent as HourGlassIcon } from "../../assets/icons/hourglass.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/check-3.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar-month.svg";
import homeService from "../../services/home.service";
import BarChartPlanning from "./BarChartPlanning";
import DashboardMyGoals from "../../components/DashboardMyGoals";
import DashboardMyCompetencies from "../../components/DashboardMyCompetencies";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { ReactComponent as DraftIcon } from "../../assets/images/iconStatus/draft.svg";
import { ReactComponent as PendingIcon } from "../../assets/images/iconStatus/pending.svg";
import { ReactComponent as ApprovedIcon } from "../../assets/images/iconStatus/approved.svg";
import { ReactComponent as CancelIcon1 } from "../../assets/images/iconStatus/cancel.svg";
import { ReactComponent as RejectIcon } from "../../assets/images/iconStatus/reject.svg";
import iconNext from "../../assets/images/news/icon-arrow-next.svg";
import iconCore from "../../assets/images/iconCore.svg";
import iconFunctional from "../../assets/images/iconFunctional.svg";
import iconManagerial from "../../assets/images/iconManagerial.svg";
import myGoals from "../../icons/myGoals.png";
import myCompetencies from "../../icons/myCompetencies.png";
import GoalsStatus from "../../components/baseComponent/GoalsStatus";
import MyAchievements from "../../components/baseComponent/MyAchievements";
import { ReactComponent as KpiArrow } from "../../icons/kpiArrow.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { makeStyles, styled } from "@mui/styles";
import Announcement from "./Announcement";
import * as Util from "../../services/global.service";

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  blueBg: {
    background: "#6694CC",
  },
  purpleBg: {
    background: "#7580BD",
  },
  customCardSize: {
    height: 380,
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
  styleText: {
    textDecoration: "underline",
    fontWeight: "500",
  },
  styleScroll: {
    color: "#5DA196",
    paddingLeft: "30px",
    paddingRight: "20px",
  },
  toggleBtnRoot: {
    background: `transparent !important`,
    color: "#6B6B6B !important",
    width: "320px",
    border: "none !important",
  },
  toggleBtnSelected: {
    background: `${cssVariables.color.primary}!important`,
    color: "#fff!important",
  },
  processBgGoals: {
    background: "#8DADC2  !important",
  },

  processBgRubric: {
    background: "#85AEB0 !important",
  },

  processBgCompetency: {
    background: "#958CCB !important",
  },

});
const styles = {
  paperContainer: {
    backgroundImage: `url(${bannerBg})`,
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    borderRadius: "10px",
    position: "relative",
  },
  bannerImage: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    maxWidth: "336px",
    height: "auto",
  },
  blueBadge: {
    background: "rgb(83 135 198 / 15%)",
    padding: "5px",
    color: "#5387C6",
  },
  blockGrid: {
    padding: "38px 0 30px 0",
    "min-height": "200px"
  },
  barLegend: {
    fontSize: "14px",
    lineHeight: "19px",
    color: "#939393",
  },
};

const Home = () => {
  const { t, i18n } = useTranslation();
  const req = useSelector((state) => state.Request);
  const stateUser = useSelector((state) => state.auth);
  const [dataHome, setDataHome] = React.useState([]);
  const [valueSerial, setValueSerial] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [dataGoals, setDataGoals] = React.useState({
    period: {
      start: "2021-10-12",
      end: "2022-10-12"
    },
    signOffDue: "2022-11-12",
    nextAction: "Review the evaluation results with your assigned manager in 1-on1 session.",
    myGoals: [
      {
        name: "On-time critical position fulfillment",
        weight: "20%",
        status: "Not Started",
      },
      {
        name: "% accuracy of HRIS data",
        weight: "20%",
        status: "In Progress",
      },
      {
        name: "Digital transform HR documents",
        weight: "20%",
        status: "Completed",
      },
      {
        name: "On-time critical",
        weight: "20%",
        status: "Not Started",
      },
      {
        name: "% accuracy ",
        weight: "10%",
        status: "In Progress",
      },
      {
        name: "Digital transform HR",
        weight: "10%",
        status: "Completed",
      },
    ],
    myCompetencies: [
      {
        name: "Communication effectiveness",
        type: "Core",
        icon: iconCore,
      },
      {
        name: "Data analysis",
        type: "Functional",
        icon: iconFunctional,
      },
      {
        name: "Stakeholder management",
        type: "Core",
        icon: iconCore,
      },
      {
        name: "Team collaboration",
        type: "Managerial",
        icon: iconManagerial,
      },
      {
        name: "Communication",
        type: "Core",
        icon: iconCore,
      },
      {
        name: "Data",
        type: "Functional",
        icon: iconFunctional,
      },
      {
        name: "Stakeholder",
        type: "Managerial",
        icon: iconManagerial,
      },
    ],
    rb_pa_data: [
      {
        status: "draft",
        status_description: "กำลังดำเนินการ",
        submitted_date: "2021-10-12"
      }
    ]
  });

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const [inboxType, setInboxType] = React.useState("goals");
  const handleButtonGroup = (_, value) => {
    if (value) setInboxType(value);
  };
  // const dispatch = useDispatch();
  // // const restList =  dispatch(getMyRequest());
  // const getMyRequest = async () => {
  //     const response = await
  //         axios.get('http://localhost:3000/Request')
  //             .catch((err) => {
  //                 console.log("err");
  //             })
  //     dispatch(getMyRequestSuccess(response.data))
  // };
  const dispatch = useDispatch();
  useEffect(() => {
    // getMyRequest();
    console.log('language', userData.language, i18n.language)

    dispatch(fetchHomeDashBoard());
    getDataHome()

    let maybeHandler = (event) => {
      if (event.target.closest(".tooltip") === null) {
        setOpen(false)
        setValueSerial("")
      }
    };

    document.addEventListener("click", maybeHandler);

    return () => {
      document.removeEventListener("click", maybeHandler);
    };
  }, []);
  const classes = useStyles();
  const handleTooltipOpen = (data) => {
    if (data !== valueSerial) {
      setOpen(true)
      setValueSerial(data)
    } else {
      setOpen(false)
      setValueSerial("")
    }
  };
  let getDataHome = () => {
    homeService.home().then(
      (response) => {
        if (response?.data?.rb_pa !== undefined) {
          setDataHome(response.data.rb_pa)
        }
      },
    );
  }
  const dateFormat = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: '2-digit',
        month: 'short',
      })
      return dateTH
    }
  }
  const dateDayFormat = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
      })
      return dateTH
    }
  }
  const dateDayFormatFull = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
      return dateTH
    }
  }
  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }
  const seq = (data) => {
    let seqs = 0
    let order = 0
    if (data !== undefined && data !== null && data !== "null") {
      for (let index = 0; index <= data.length - 1; index++) {
        if (seqs < data[index].seq) {
          seqs = data[index].seq
          order = index
        }
      }
      return data[order]
    }
    // return {}
  }
  let callBackPath = (path) => {
    navigate(path, { replace: false });

  }
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));
  return (
    <>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} xs={12}>
              <Box mt={6} width="100%">
                <Paper style={styles.paperContainer}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={4}
                      xs={4}
                      style={{ position: "relative" }}
                    >
                      <img
                        src={bannerImg}
                        alt="bannerImage"
                        style={styles.bannerImage}
                      />
                    </Grid>
                    <Grid item lg={8} xs={8} style={styles.blockGrid} sx={{ position: "relative" }}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Typography fontSize={14} lineHeight="15.4px">
                            {/*{t("home.label.banner.hello")} Mr.PMS{" "}*/}
                            สวัสดี, {stateUser?.user?.profile?.academic_title}{stateUser?.user?.profile?.firstname} {stateUser?.user?.profile?.lastname}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Typography
                            fontSize={36}
                            lineHeight="39.6px"
                            sx={{ paddingTop: "11px", fontWeight: "medium" }}
                          >
                            {/*{t("home.label.banner.welcome-to-pms")}*/}
                            ยินดีต้อนรับเข้าสู่ระบบ PMS
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box sx={{ position: "absolute", bottom: "21px", right: "21px", display: "flex", alignItems: "Center", justifyContent: "space-between" }} >
                        <Button className={classes.processBgGoals} sx={{ "border-radius": '22px', minWidth: '82px', marginRight: '16px', padding: "15px", display: "flex", flexDirection: "row", alignItems: "Center", cursor: 'pointer' }} onClick={() => navigate("/kpi/manual/listbooks", { replace: false })}>

                          <Typography fontSize={18} lineHeight="20px" fontWeight={600} color="#FFFFFF">
                            {t("handbook.label.handbook")}
                          </Typography>

                          <img src={iconNext} style={{ maxWidth: '28px', maxHeight: '20px', marginLeft: '8px' }}>

                          </img>
                        </Button>

                      </Box>

                      {dataHome.length > 0 ?
                        dataHome.map((loRow, index) => (
                          loRow?.rb_pa_data.length > 0 ?
                            <Grid container spacing={1}>
                              <Grid item>
                                <Typography
                                  fontSize={18}
                                  lineHeight="27px"
                                  sx={{ paddingTop: "10px", maxWidth: "860px" }}
                                >
                                  ในขณะนี้ระบบได้เปิดทำการให้บุคลากรทุกท่านวางแผนการประเมิน
                                  เพื่อใช้ใน
                                  <span className={classes.styleText}>
                                    รอบประเมินปีพ.ศ. 2565
                                  </span>{" "}
                                  ได้ตั้งแต่วันนี้เป็นต้นไป จนถึง <span className={classes.styleText}>วันที่ {loRow?.rb_pa_data.length > 0 ? `${dateDayFormatFull(seq(loRow?.rb_pa_data)?.before)}` : "-"}</span>
                                </Typography>
                              </Grid>
                            </Grid>
                            : null
                        ))
                        : null}
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
            <Announcement />

            <Grid sx={{ width: "100%", "padding-top": "14px", "padding-bottom": "30px", "margin-left": "16px" }}>
              <Divider />
            </Grid>
          </Grid>
          {Object.keys(dataGoals).length > 0 && dataHome.length > 0 ?
            <Box>
              <Grid container pb="14px">
                <Grid item xs sm md lg sx={{ "padding-top": "0 !important" }}>
                  <Box sx={{ width: "100%" }}>
                    <ToggleButtonGroup
                      value={inboxType}
                      onChange={handleButtonGroup}
                      aria-label="inbox type"
                      exclusive={true}
                    >
                      <ToggleButton
                        value="goals"
                        aria-label="centered"
                        classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                        sx={{ "border-radius": "10px 10px 0px 0px !important" }}
                      >
                        <Typography>Goals & Competency</Typography>
                      </ToggleButton>
                      <ToggleButton
                        value="rubric"
                        aria-label="centered"
                        sx={{ "border-radius": "10px 10px 0px 0px !important" }}
                        classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                      >
                        <Typography>Rubric</Typography>
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <Divider />
                  </Box>
                </Grid>
              </Grid>
              {inboxType === "rubric" ?
                dataHome.map((loRow, index) => (
                  <Box>
                    <Grid container spacing={2}>
                      <Grid item sx={{ width: "100%" }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <Typography
                            fontSize={24}
                            lineHeight="26.4px"
                            variant="h2"
                            className="fw_600"
                          >
                            {loRow?.rb_pa_data.length > 0 ? loRow?.rb_pa_data[0]?.description : ""}
                          </Typography>
                          <Box sx={{ flex: 2 }}></Box>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Box>
                              {/* <Button startIcon={<EditIcon />} sx={{ height: "35px" }} variant="contained" >แก้ไข</Button> */}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid container item pb={2} pt={2}>
                      <Grid item xs sm md lg>
                        <Card sx={{ height: 1 }}>
                          <CardContent sx={{ px: 2 }}>
                            <Grid container mt={0}>
                              {/* <Grid
                      item
                      display="flex"
                      sx={{
                        flexFlow: "column",
                      }}
                    >
                      <Typography variant="h3">ภาพรวมข้อตกลงภาระงาน</Typography>
                    </Grid> */}
                              <Grid container spacing={0}>
                                <Grid item>
                                  <div
                                    className={`${classes.iconContainer}`}
                                    style={{ background: "#5DA196" }}
                                  >
                                    <img src={file} alt="bannerImage" />
                                  </div>
                                </Grid>
                                <Grid item ml={1} display="flex" alignItems="center">
                                  <Grid container spacing={0}>
                                    <Grid item>
                                      <Typography
                                        fontSize={20}
                                        lineHeight="22px"
                                        sx={{ fontWeight: "600" }}
                                      >
                                        ภาพรวมข้อตกลงภาระงาน
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid sx={{ paddingTop: "10px" }}>
                              <Divider />
                            </Grid>
                            <Grid container mt={2} display="flex" alignItems="center">
                              <Grid item mr={1}>
                                <CalendarIcon></CalendarIcon>
                              </Grid>
                              <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                                <Box sx={{ width: "150px" }}>
                                  <Typography variant="sub_label">
                                    รอบข้อตกลงภาระงาน:
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs sm md>
                                <Typography>{loRow?.rb_pa_data.length > 0 ? `${dateFormat(seq(loRow?.rb_pa_data)?.start)} - ${dateFormat(seq(loRow?.rb_pa_data)?.end)}` : "-"}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container mt={1} display="flex" alignItems="center">
                              <Grid item mr={1}>
                                <CalendarIcon></CalendarIcon>
                              </Grid>
                              <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                                <Box sx={{ width: "150px" }}>
                                  <Typography variant="sub_label">
                                    ส่งภายในวันที่:
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs sm md>
                                <Typography>{loRow?.rb_pa_data.length > 0 ? `${dateDayFormat(seq(loRow?.rb_pa_data)?.before)}` : "-"}</Typography>
                              </Grid>
                            </Grid>
                            {/* status box */}
                            <Grid container mt={2} sx={{ maxWidth: "100%" }}>
                              <Grid item xs sm md lg>
                                {loRow.rb_pa_data !== undefined && loRow?.rb_pa_data !== null ?
                                  <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          loRow.rb_pa_data[0]?.status === "draft" ?
                                            "#F7B2541A"
                                            : loRow.rb_pa_data[0]?.status === "pending" ?
                                              "#F280261A"
                                              : loRow.rb_pa_data[0]?.status === "approved" ?
                                                "#5DA1961A"
                                                : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          loRow.rb_pa_data[0]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : loRow.rb_pa_data[0]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : loRow.rb_pa_data[0]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"

                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                      >
                                        <Box
                                          style={{
                                            background:
                                              loRow.rb_pa_data[0]?.status === "draft" ?
                                                "#F9C47F"
                                                : loRow.rb_pa_data[0]?.status === "pending" ?
                                                  "#F28026"
                                                  : loRow.rb_pa_data[0]?.status === "approved" ?
                                                    "#5DA196"
                                                    : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              loRow.rb_pa_data[0]?.status === "draft" ||
                                                loRow.rb_pa_data[0]?.status === "pending" ||
                                                loRow.rb_pa_data[0]?.status === "approved" ||
                                                loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "rejected" ||
                                                loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {/* <CheckIcon></CheckIcon> */}
                                          {
                                            loRow.rb_pa_data[0]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : loRow.rb_pa_data[0]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : loRow.rb_pa_data[0]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography fontSize="18" fontWeight="600"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[0]?.status === "draft" ||
                                                  loRow.rb_pa_data[0]?.status === "pending" ||
                                                  loRow.rb_pa_data[0]?.status === "approved" ||
                                                  loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "rejected" ||
                                                  loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            จัดทำข้อตกลงภาระงาน
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[0]?.status === "draft" ||
                                                  loRow.rb_pa_data[0]?.status === "pending" ||
                                                  loRow.rb_pa_data[0]?.status === "approved" ||
                                                  loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "rejected" ||
                                                  loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            สถานะ : {formatData(loRow.rb_pa_data[0]?.status_description, "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[0]?.status === "draft" ||
                                                  loRow.rb_pa_data[0]?.status === "pending" ||
                                                  loRow.rb_pa_data[0]?.status === "approved" ||
                                                  loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "rejected" ||
                                                  loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[0]?.send_at), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <InfoIcon></InfoIcon>
                                      </Box>
                                    </div>
                                    {/* connector */}
                                    <div
                                      style={{
                                        borderTop: "3px dashed #E5E5E5",
                                        width: "100%",
                                        maxWidth: "10%"
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          loRow.rb_pa_data[1]?.status === "draft" ?
                                            "#F7B2541A"
                                            : loRow.rb_pa_data[1]?.status === "pending" ?
                                              "#F280261A"
                                              : loRow.rb_pa_data[1]?.status === "approved" ?
                                                "#5DA1961A"
                                                : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          loRow.rb_pa_data[1]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : loRow.rb_pa_data[1]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : loRow.rb_pa_data[1]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"
                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                      >
                                        <Box
                                          style={{
                                            background:
                                              loRow.rb_pa_data[1]?.status === "draft" ?
                                                "#F9C47F"
                                                : loRow.rb_pa_data[1]?.status === "pending" ?
                                                  "#F28026"
                                                  : loRow.rb_pa_data[1]?.status === "approved" ?
                                                    "#5DA196"
                                                    : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              loRow.rb_pa_data[1]?.status === "draft" ||
                                                loRow.rb_pa_data[1]?.status === "pending" ||
                                                loRow.rb_pa_data[1]?.status === "approved" ||
                                                loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "rejected" ||
                                                loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {
                                            loRow.rb_pa_data[1]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : loRow.rb_pa_data[1]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : loRow.rb_pa_data[1]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography fontSize="18" fontWeight="600"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[1]?.status === "draft" ||
                                                  loRow.rb_pa_data[1]?.status === "pending" ||
                                                  loRow.rb_pa_data[1]?.status === "approved" ||
                                                  loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "rejected" ||
                                                  loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            บันทึกภาระงาน
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[1]?.status === "draft" ||
                                                  loRow.rb_pa_data[1]?.status === "pending" ||
                                                  loRow.rb_pa_data[1]?.status === "approved" ||
                                                  loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "rejected" ||
                                                  loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            สถานะ : {formatData(loRow.rb_pa_data[1]?.status_description, "ยังไม่ดำเนินการ")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[1]?.status === "draft" ||
                                                  loRow.rb_pa_data[1]?.status === "pending" ||
                                                  loRow.rb_pa_data[1]?.status === "approved" ||
                                                  loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "rejected" ||
                                                  loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[1]?.send_at), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <InfoIcon></InfoIcon>
                                      </Box>
                                    </div>
                                    {/* connector */}
                                    <div
                                      style={{
                                        borderTop: "3px dashed #E5E5E5",
                                        width: "100%",
                                        maxWidth: "10%"
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          loRow.rb_pa_data[2]?.status === "draft" ?
                                            "#F7B2541A"
                                            : loRow.rb_pa_data[2]?.status === "pending" ?
                                              "#F280261A"
                                              : loRow.rb_pa_data[2]?.status === "approved" ?
                                                "#5DA1961A"
                                                : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          loRow.rb_pa_data[2]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : loRow.rb_pa_data[2]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : loRow.rb_pa_data[2]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"
                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                      >
                                        <Box
                                          style={{
                                            background:
                                              loRow.rb_pa_data[1]?.status === "draft" ?
                                                "#F9C47F"
                                                : loRow.rb_pa_data[1]?.status === "pending" ?
                                                  "#F28026"
                                                  : loRow.rb_pa_data[1]?.status === "approved" ?
                                                    "#5DA196"
                                                    : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              loRow.rb_pa_data[1]?.status === "draft" ||
                                                loRow.rb_pa_data[1]?.status === "pending" ||
                                                loRow.rb_pa_data[1]?.status === "approved" ||
                                                loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "rejected" ||
                                                loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {
                                            loRow.rb_pa_data[2]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : loRow.rb_pa_data[2]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : loRow.rb_pa_data[2]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            fontSize="18"
                                            fontWeight="600"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[2]?.status === "draft" ||
                                                  loRow.rb_pa_data[2]?.status === "pending" ||
                                                  loRow.rb_pa_data[2]?.status === "approved" ||
                                                  loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "rejected" ||
                                                  loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            รับทราบผลข้อตกลงภาระงาน
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[2]?.status === "draft" ||
                                                  loRow.rb_pa_data[2]?.status === "pending" ||
                                                  loRow.rb_pa_data[2]?.status === "approved" ||
                                                  loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "rejected" ||
                                                  loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            สถานะ : {formatData(loRow.rb_pa_data[2]?.status_description, "ยังไม่ดำเนินการ")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                loRow.rb_pa_data[2]?.status === "draft" ||
                                                  loRow.rb_pa_data[2]?.status === "pending" ||
                                                  loRow.rb_pa_data[2]?.status === "approved" ||
                                                  loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "rejected" ||
                                                  loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  loRow.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[2]?.send_at), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <InfoIcon></InfoIcon>
                                      </Box>
                                    </div>
                                  </Box>
                                  : null
                                }
                              </Grid>
                            </Grid>
                            {/* end status box */}
                            {/* <Grid container mt={2}>
                          <Grid item xs sm md lg display="flex" alignItems="center">
                            <Box sx={{ mr: 1 }}><InfoIcon></InfoIcon></Box>
                            <Typography variant="label" sx={{ mr: 1 }}>
                              ขั้นตอนถัดไป:
                            </Typography>
                            <Typography variant="sub_label">ส่งขออนุมัติจัดทำข้อตกลงภาระงานทางวิชาการประจำปี</Typography>
                          </Grid>
                        </Grid> */}
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={1}>
                      <Grid item lg={6} md={6} xs={12}>
                        <BarChartPlanning data={loRow?.planning} icon={planningImg} color={"#4978B9"} title={t("home.label.paPlanning")} callBack={callBackPath} path={loRow?.planning?.id !== undefined && loRow?.planning?.id !== null ? "/app/planning/" + loRow?.planning?.id : ""} />
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <BarChartPlanning data={loRow?.Actual} icon={saveImg} color={"#8470B8"} title={t("home.label.paActual")} callBack={callBackPath} path={loRow?.Actual?.id !== undefined && loRow?.Actual?.id !== null ? "/app/planning/" + loRow?.Actual?.id : ""} />
                      </Grid>
                    </Grid>
                    <Grid sx={{ width: "100%", "padding-top": "30px", "padding-bottom": "30px" }}>
                      <Divider />
                    </Grid>
                  </Box>
                ))
                :
                inboxType === "goals" ?
                  <Box>
                    <Grid container item pb={2} pt={2}>
                      <Grid item xs sm md lg sx={{ height: 1 }}>
                        <Card sx={{ height: 1, overflow: "unset" }}>
                          <CardContent sx={{ px: 2 }} style={{ "padding-bottom": "20px" }}>
                            <Grid container spacing={0} justifyContent="space-between">
                              <Grid item sx={{ display: "flex", "align-items": "center" }}>
                                <div
                                  className={`${classes.iconContainer}`}
                                  style={{ background: "#5DA196" }}
                                >
                                  <img src={overview} alt="bannerImage" />
                                </div>
                                <Typography
                                  fontSize={20}
                                  ml="15px"
                                  lineHeight="22px"
                                  sx={{ fontWeight: "600" }}
                                >
                                  Overview & Achievements
                                </Typography>
                              </Grid>
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box mt="4px">
                                  {/* {data?.code === "y" ? */}
                                  <BootstrapTooltip title={`View my achievements`} placement="top">
                                    <KpiArrow style={{ cursor: "pointer" }} />
                                  </BootstrapTooltip>
                                  {/* : null
                              } */}
                                </Box>
                              </Box>
                            </Grid>
                            <Grid sx={{ width: "100%", "padding-top": "20px" }}>
                              <Divider />
                            </Grid>
                            <Grid container spacing={4}>
                              <Grid item xs={12} display="flex">
                                <Grid item sx={{ "min-width": "450px", width: "35%" }} >
                                  <GoalsStatus />
                                </Grid>
                                <Grid item sx={{ width: "65%" }}>
                                  <MyAchievements />
                                </Grid>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                    <Grid container item pb={2} pt={2}>
                      <Grid item xs sm md lg sx={{ height: 1 }}>
                        <Card sx={{ height: 1, overflow: "unset" }}>
                          <CardContent sx={{ px: 2 }}>
                            <Grid container spacing={0} justifyContent="space-between">
                              <Grid item sx={{ display: "flex", "align-items": "center" }}>
                                <div
                                  className={`${classes.iconContainer}`}
                                  style={{ background: "#5DA196" }}
                                >
                                  <img src={file} alt="bannerImage" />
                                </div>
                                <Box item>
                                  <Typography
                                    fontSize={20}
                                    ml="15px"
                                    lineHeight="22px"
                                    sx={{ fontWeight: "600" }}
                                  >
                                    Performance Evaluation Overview
                                  </Typography>
                                </Box>
                              </Grid>
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box mt="4px">
                                  {/* {data?.code === "y" ? */}
                                  <BootstrapTooltip title={`View my evaluation`} placement="top">
                                    <KpiArrow style={{ cursor: "pointer" }} />
                                  </BootstrapTooltip>
                                  {/* : null
                              } */}
                                </Box>
                              </Box>
                            </Grid>
                            <Grid sx={{ width: "100%", "padding-top": "23px" }}>
                              <Divider />
                            </Grid>
                            <Grid sx={{ width: "100%", "padding-top": "15px", display: "flex", alignItems: "center" }}>
                              <CalendarIcon /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px"> Performance evaluation period: August 2020-July 2021</Typography>
                            </Grid>
                            <Grid sx={{ width: "100%", "padding-top": "20px", "padding-bottom": "19px", display: "flex", alignItems: "center" }}>
                              <CalendarIcon /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px"> Sign-off due date: September 30, 2021</Typography>
                            </Grid>
                            <Grid container spacing={4}>
                              <Grid item xs={12} display="flex">
                                {dataGoals.rb_pa_data !== undefined && dataGoals?.rb_pa_data !== null ?
                                  <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          dataGoals.rb_pa_data[0]?.status === "draft" ?
                                            "#F7B2541A"
                                            : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                              "#F280261A"
                                              : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                "#5DA1961A"
                                                : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          dataGoals.rb_pa_data[0]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"

                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "start" }}
                                      >
                                        <Box
                                          mt="4px"
                                          style={{
                                            background:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ?
                                                "#F9C47F"
                                                : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                                  "#F28026"
                                                  : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                    "#5DA196"
                                                    : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {/* <CheckIcon></CheckIcon> */}
                                          {
                                            dataGoals.rb_pa_data[0]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                          <Typography fontSize="18" fontWeight="600"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Goal and competency review and self-evaluation
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Status: {formatData(dataGoals.rb_pa_data[0]?.status_description, "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[0]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[0]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <div style={{ width: "max-content" }}>
                                          <BootstrapTooltip
                                            style={{ width: "max-content" }}
                                            onClose={e => handleTooltipOpen("1")}
                                            open={open === true && valueSerial === "1" ? true : false}
                                            placement="top"
                                            arrow
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            title={`Give honest feedback on how you perceive your performance.`}
                                          >
                                            <InfoIcon style={{ cursor: "pointer" }} />
                                          </BootstrapTooltip>
                                          <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                        </div>
                                      </Box>
                                    </div>
                                    {/* connector */}
                                    <div
                                      style={{
                                        borderTop: "3px dashed #E5E5E5",
                                        width: "100%",
                                        maxWidth: "65px"
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          dataGoals.rb_pa_data[1]?.status === "draft" ?
                                            "#F7B2541A"
                                            : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                              "#F280261A"
                                              : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                "#5DA1961A"
                                                : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          dataGoals.rb_pa_data[1]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"
                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "start" }}
                                      >
                                        <Box
                                          mt="4px"
                                          style={{
                                            background:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ?
                                                "#F9C47F"
                                                : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                                  "#F28026"
                                                  : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                    "#5DA196"
                                                    : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {
                                            dataGoals.rb_pa_data[1]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                          <Typography fontSize="18" fontWeight="600"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Evaluator review the evaluation
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Status: {formatData(dataGoals.rb_pa_data[1]?.status_description, "ยังไม่ดำเนินการ")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[1]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[1]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <div style={{ width: "max-content" }}>
                                          <BootstrapTooltip
                                            style={{ width: "max-content" }}
                                            onClose={e => handleTooltipOpen("2")}
                                            open={open === true && valueSerial === "2" ? true : false}
                                            placement="top"
                                            arrow
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            title={`Feedback the performance and how others perceive your performance.`}
                                          >
                                            <InfoIcon style={{ cursor: "pointer" }} />
                                          </BootstrapTooltip>
                                          <div className='tooltip' onClick={e => handleTooltipOpen("2")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                        </div>
                                      </Box>
                                    </div>
                                    {/* connector */}
                                    <div
                                      style={{
                                        borderTop: "3px dashed #E5E5E5",
                                        width: "100%",
                                        maxWidth: "65px"
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          dataGoals.rb_pa_data[2]?.status === "draft" ?
                                            "#F7B2541A"
                                            : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                              "#F280261A"
                                              : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                "#5DA1961A"
                                                : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          dataGoals.rb_pa_data[2]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"
                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "start" }}
                                      >
                                        <Box
                                          mt="4px"
                                          style={{
                                            background:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ?
                                                "#F9C47F"
                                                : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                                  "#F28026"
                                                  : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                    "#5DA196"
                                                    : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {
                                            dataGoals.rb_pa_data[2]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                          <Typography
                                            fontSize="18"
                                            fontWeight="600"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Evaluation review and 1-on-1 session
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Status: {formatData(dataGoals.rb_pa_data[2]?.status_description, "ยังไม่ดำเนินการ")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          pb: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[2]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[2]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <div style={{ width: "max-content" }}>
                                          <BootstrapTooltip
                                            style={{ width: "max-content" }}
                                            onClose={e => handleTooltipOpen("3")}
                                            open={open === true && valueSerial === "3" ? true : false}
                                            placement="top"
                                            arrow
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            title={`Evaluate that individual's overall performance, identify their strengths and weaknesses, offer feedback, and help them set goals.`}
                                          >
                                            <InfoIcon style={{ cursor: "pointer" }} />
                                          </BootstrapTooltip>
                                          <div className='tooltip' onClick={e => handleTooltipOpen("3")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                        </div>
                                      </Box>
                                    </div>
                                    {/* connector */}
                                    <div
                                      style={{
                                        borderTop: "3px dashed #E5E5E5",
                                        width: "100%",
                                        maxWidth: "65px"
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        maxWidth: "380px",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                          dataGoals.rb_pa_data[3]?.status === "draft" ?
                                            "#F7B2541A"
                                            : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                              "#F280261A"
                                              : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                "#5DA1961A"
                                                : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                    "#CC60581A"
                                                    : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                      "#F280261A"
                                                      : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                        "#8282821A" : "#FFFFFF",
                                        border:
                                          dataGoals.rb_pa_data[3]?.status === "draft" ?
                                            "1px solid #F9C47F"
                                            : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                              "1px solid #F28026"
                                              : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                "1px solid #5DA196"
                                                : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                    "1px solid #CC6058"
                                                    : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                      "1px solid #F28026"
                                                      : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                        "1px solid #828282" : "1px solid #DADADA",
                                        borderRadius: "5px",
                                        position: "relative",
                                        paddingBottom: "25px"
                                      }}
                                    >
                                      <Box
                                        sx={{ p: 1, display: "flex", alignItems: "start" }}
                                      >
                                        <Box
                                          mt="4px"
                                          style={{
                                            background:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ?
                                                "#F9C47F"
                                                : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                                  "#F28026"
                                                  : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                    "#5DA196"
                                                    : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                        "#CC6058"
                                                        : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                          "#F28026"
                                                          : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                            "#828282" : "#FAFAFA",
                                            border:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                "none" : "1px dashed #C4C4C4",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {
                                            dataGoals.rb_pa_data[3]?.status === "draft" ?
                                              <DraftIcon></DraftIcon>
                                              : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                                <PendingIcon></PendingIcon>
                                                : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                    <CancelIcon1></CancelIcon1>
                                                    : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                      <RejectIcon></RejectIcon>
                                                      : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                        <PendingIcon></PendingIcon>
                                                        : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                          <CancelIcon1></CancelIcon1>
                                                          : null
                                          }
                                        </Box>
                                        <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                          <Typography
                                            fontSize="18"
                                            fontWeight="600"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Employee and Evaluator sign off
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Status: {formatData(dataGoals.rb_pa_data[3]?.status_description, "ยังไม่ดำเนินการ")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography
                                            variant="h6"
                                            fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}
                                          >
                                            Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[3]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          px: 1,
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            width: "30px",
                                          }}
                                        ></Box>
                                        <Box sx={{ ml: 2 }}>
                                          <Typography variant="h6" fontWeight="400"
                                            sx={{
                                              color:
                                                dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                  dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                  dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                  dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                  "#404349"
                                                  : "#C4C4C4"
                                            }}>
                                            Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[3]?.submitted_date), "-")}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                          top: 0,
                                          margin: 6,
                                        }}
                                      >
                                        <div style={{ width: "max-content" }}>
                                          <BootstrapTooltip
                                            style={{ width: "max-content" }}
                                            onClose={e => handleTooltipOpen("4")}
                                            open={open === true && valueSerial === "4" ? true : false}
                                            placement="top"
                                            arrow
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            title={`Acknowledgement that the performance evaluation review and discussion between you and your manager have been held.`}
                                          >
                                            <InfoIcon style={{ cursor: "pointer" }} />
                                          </BootstrapTooltip>
                                          <div className='tooltip' onClick={e => handleTooltipOpen("4")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                        </div>
                                      </Box>
                                    </div>
                                  </Box>
                                  : null
                                }
                              </Grid>
                              {dataGoals.rb_pa_data !== undefined && dataGoals?.rb_pa_data !== null ?
                                <Grid item xs={12} display="flex" pt="15px !important" sx={{ "svg": { width: "18px", height: "18px" } }}>
                                  <InfoIcon />
                                  <Typography ml="12px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "400" }} >Next action: </Typography>
                                  <Typography ml="5px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "300" }} >Review the evaluation results with your assigned manager in 1-on1 session</Typography>
                                </Grid>
                                : null
                              }
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={1}>
                      <Grid item lg={6} md={6} xs={12}>
                        <DashboardMyGoals icon={myGoals} title="My Goal" data={dataGoals.myGoals} />
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <DashboardMyCompetencies icon={myCompetencies} title="My Competencies" data={dataGoals.myCompetencies} />
                      </Grid>
                    </Grid>
                    <Grid sx={{ width: "100%", "padding-top": "30px", "padding-bottom": "30px" }}>
                      <Divider />
                    </Grid>
                  </Box >
                  : null
              }
            </Box>
            :
            dataHome.length > 0 ?
              dataHome.map((loRow, index) => (
                <Box>
                  <Grid container spacing={2}>
                    <Grid item sx={{ width: "100%" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography
                          fontSize={24}
                          lineHeight="26.4px"
                          variant="h2"
                          className="fw_600"
                        >
                          {loRow?.rb_pa_data.length > 0 ? loRow?.rb_pa_data[0]?.description : ""}
                        </Typography>
                        <Box sx={{ flex: 2 }}></Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <Box>
                            {/* <Button startIcon={<EditIcon />} sx={{ height: "35px" }} variant="contained" >แก้ไข</Button> */}
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container item pb={2} pt={2}>
                    <Grid item xs sm md lg>
                      <Card sx={{ height: 1 }}>
                        <CardContent sx={{ px: 2 }}>
                          <Grid container mt={0}>
                            {/* <Grid
                      item
                      display="flex"
                      sx={{
                        flexFlow: "column",
                      }}
                    >
                      <Typography variant="h3">ภาพรวมข้อตกลงภาระงาน</Typography>
                    </Grid> */}
                            <Grid container spacing={0}>
                              <Grid item>
                                <div
                                  className={`${classes.iconContainer} ${classes.blueBg}`}
                                >
                                  <img src={overview} alt="bannerImage" />
                                </div>
                              </Grid>
                              <Grid item ml={1} display="flex" alignItems="center">
                                <Grid container spacing={0}>
                                  <Grid item>
                                    <Typography
                                      fontSize={20}
                                      lineHeight="22px"
                                      sx={{ fontWeight: "600" }}
                                    >
                                      ภาพรวมข้อตกลงภาระงาน
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid sx={{ paddingTop: "10px" }}>
                            <Divider />
                          </Grid>
                          <Grid container mt={2} display="flex" alignItems="center">
                            <Grid item mr={1}>
                              <CalendarIcon></CalendarIcon>
                            </Grid>
                            <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                              <Box sx={{ width: "150px" }}>
                                <Typography variant="sub_label">
                                  รอบข้อตกลงภาระงาน:
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs sm md>
                              <Typography>{loRow?.rb_pa_data.length > 0 ? `${dateFormat(seq(loRow?.rb_pa_data)?.start)} - ${dateFormat(seq(loRow?.rb_pa_data)?.end)}` : "-"}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container mt={1} display="flex" alignItems="center">
                            <Grid item mr={1}>
                              <CalendarIcon></CalendarIcon>
                            </Grid>
                            <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                              <Box sx={{ width: "150px" }}>
                                <Typography variant="sub_label">
                                  ส่งภายในวันที่:
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs sm md>
                              <Typography>{loRow?.rb_pa_data.length > 0 ? `${dateDayFormat(seq(loRow?.rb_pa_data)?.before)}` : "-"}</Typography>
                            </Grid>
                          </Grid>
                          {/* status box */}
                          <Grid container mt={2} sx={{ maxWidth: "100%" }}>
                            <Grid item xs sm md lg>
                              {loRow.rb_pa_data !== undefined && loRow?.rb_pa_data !== null ?
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        loRow.rb_pa_data[0]?.status === "draft" ?
                                          "#F7B2541A"
                                          : loRow.rb_pa_data[0]?.status === "pending" ?
                                            "#F280261A"
                                            : loRow.rb_pa_data[0]?.status === "approved" ?
                                              "#5DA1961A"
                                              : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        loRow.rb_pa_data[0]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : loRow.rb_pa_data[0]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : loRow.rb_pa_data[0]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"

                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "center" }}
                                    >
                                      <Box
                                        style={{
                                          background:
                                            loRow.rb_pa_data[0]?.status === "draft" ?
                                              "#F9C47F"
                                              : loRow.rb_pa_data[0]?.status === "pending" ?
                                                "#F28026"
                                                : loRow.rb_pa_data[0]?.status === "approved" ?
                                                  "#5DA196"
                                                  : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            loRow.rb_pa_data[0]?.status === "draft" ||
                                              loRow.rb_pa_data[0]?.status === "pending" ||
                                              loRow.rb_pa_data[0]?.status === "approved" ||
                                              loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                              loRow.rb_pa_data[0]?.status === "rejected" ||
                                              loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                              loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* <CheckIcon></CheckIcon> */}
                                        {
                                          loRow.rb_pa_data[0]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : loRow.rb_pa_data[0]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : loRow.rb_pa_data[0]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : loRow.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : loRow.rb_pa_data[0]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : loRow.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : loRow.rb_pa_data[0]?.status === "cancel_cancel" || loRow.rb_pa_data[0]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography fontSize="18" fontWeight="600"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[0]?.status === "draft" ||
                                                loRow.rb_pa_data[0]?.status === "pending" ||
                                                loRow.rb_pa_data[0]?.status === "approved" ||
                                                loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "rejected" ||
                                                loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          จัดทำข้อตกลงภาระงาน
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[0]?.status === "draft" ||
                                                loRow.rb_pa_data[0]?.status === "pending" ||
                                                loRow.rb_pa_data[0]?.status === "approved" ||
                                                loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "rejected" ||
                                                loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          สถานะ : {formatData(loRow.rb_pa_data[0]?.status_description, "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[0]?.status === "draft" ||
                                                loRow.rb_pa_data[0]?.status === "pending" ||
                                                loRow.rb_pa_data[0]?.status === "approved" ||
                                                loRow.rb_pa_data[0]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "rejected" ||
                                                loRow.rb_pa_data[0]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[0]?.send_at), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <InfoIcon></InfoIcon>
                                    </Box>
                                  </div>
                                  {/* connector */}
                                  <div
                                    style={{
                                      borderTop: "3px dashed #E5E5E5",
                                      width: "100%",
                                      maxWidth: "10%"
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        loRow.rb_pa_data[1]?.status === "draft" ?
                                          "#F7B2541A"
                                          : loRow.rb_pa_data[1]?.status === "pending" ?
                                            "#F280261A"
                                            : loRow.rb_pa_data[1]?.status === "approved" ?
                                              "#5DA1961A"
                                              : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        loRow.rb_pa_data[1]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : loRow.rb_pa_data[1]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : loRow.rb_pa_data[1]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"
                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "center" }}
                                    >
                                      <Box
                                        style={{
                                          background:
                                            loRow.rb_pa_data[1]?.status === "draft" ?
                                              "#F9C47F"
                                              : loRow.rb_pa_data[1]?.status === "pending" ?
                                                "#F28026"
                                                : loRow.rb_pa_data[1]?.status === "approved" ?
                                                  "#5DA196"
                                                  : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            loRow.rb_pa_data[1]?.status === "draft" ||
                                              loRow.rb_pa_data[1]?.status === "pending" ||
                                              loRow.rb_pa_data[1]?.status === "approved" ||
                                              loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                              loRow.rb_pa_data[1]?.status === "rejected" ||
                                              loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                              loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {
                                          loRow.rb_pa_data[1]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : loRow.rb_pa_data[1]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : loRow.rb_pa_data[1]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography fontSize="18" fontWeight="600"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[1]?.status === "draft" ||
                                                loRow.rb_pa_data[1]?.status === "pending" ||
                                                loRow.rb_pa_data[1]?.status === "approved" ||
                                                loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "rejected" ||
                                                loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          บันทึกภาระงาน
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[1]?.status === "draft" ||
                                                loRow.rb_pa_data[1]?.status === "pending" ||
                                                loRow.rb_pa_data[1]?.status === "approved" ||
                                                loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "rejected" ||
                                                loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          สถานะ : {formatData(loRow.rb_pa_data[1]?.status_description, "ยังไม่ดำเนินการ")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[1]?.status === "draft" ||
                                                loRow.rb_pa_data[1]?.status === "pending" ||
                                                loRow.rb_pa_data[1]?.status === "approved" ||
                                                loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "rejected" ||
                                                loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[1]?.send_at), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <InfoIcon></InfoIcon>
                                    </Box>
                                  </div>
                                  {/* connector */}
                                  <div
                                    style={{
                                      borderTop: "3px dashed #E5E5E5",
                                      width: "100%",
                                      maxWidth: "10%"
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        loRow.rb_pa_data[2]?.status === "draft" ?
                                          "#F7B2541A"
                                          : loRow.rb_pa_data[2]?.status === "pending" ?
                                            "#F280261A"
                                            : loRow.rb_pa_data[2]?.status === "approved" ?
                                              "#5DA1961A"
                                              : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        loRow.rb_pa_data[2]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : loRow.rb_pa_data[2]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : loRow.rb_pa_data[2]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"
                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "center" }}
                                    >
                                      <Box
                                        style={{
                                          background:
                                            loRow.rb_pa_data[1]?.status === "draft" ?
                                              "#F9C47F"
                                              : loRow.rb_pa_data[1]?.status === "pending" ?
                                                "#F28026"
                                                : loRow.rb_pa_data[1]?.status === "approved" ?
                                                  "#5DA196"
                                                  : loRow.rb_pa_data[1]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : loRow.rb_pa_data[1]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : loRow.rb_pa_data[1]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : loRow.rb_pa_data[1]?.status === "cancel_cancel" || loRow.rb_pa_data[1]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            loRow.rb_pa_data[1]?.status === "draft" ||
                                              loRow.rb_pa_data[1]?.status === "pending" ||
                                              loRow.rb_pa_data[1]?.status === "approved" ||
                                              loRow.rb_pa_data[1]?.status === "approved_cancel" ||
                                              loRow.rb_pa_data[1]?.status === "rejected" ||
                                              loRow.rb_pa_data[1]?.status === "pending_cancel" ||
                                              loRow.rb_pa_data[1]?.status === "cancel_cancel" ||
                                              loRow.rb_pa_data[1]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {
                                          loRow.rb_pa_data[2]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : loRow.rb_pa_data[2]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : loRow.rb_pa_data[2]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : loRow.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : loRow.rb_pa_data[2]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : loRow.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : loRow.rb_pa_data[2]?.status === "cancel_cancel" || loRow.rb_pa_data[2]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          fontSize="18"
                                          fontWeight="600"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[2]?.status === "draft" ||
                                                loRow.rb_pa_data[2]?.status === "pending" ||
                                                loRow.rb_pa_data[2]?.status === "approved" ||
                                                loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "rejected" ||
                                                loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          รับทราบผลข้อตกลงภาระงาน
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[2]?.status === "draft" ||
                                                loRow.rb_pa_data[2]?.status === "pending" ||
                                                loRow.rb_pa_data[2]?.status === "approved" ||
                                                loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "rejected" ||
                                                loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          สถานะ : {formatData(loRow.rb_pa_data[2]?.status_description, "ยังไม่ดำเนินการ")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              loRow.rb_pa_data[2]?.status === "draft" ||
                                                loRow.rb_pa_data[2]?.status === "pending" ||
                                                loRow.rb_pa_data[2]?.status === "approved" ||
                                                loRow.rb_pa_data[2]?.status === "approved_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "rejected" ||
                                                loRow.rb_pa_data[2]?.status === "pending_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                loRow.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          วันที่: {formatData(dateDayFormat(loRow.rb_pa_data[2]?.send_at), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <InfoIcon></InfoIcon>
                                    </Box>
                                  </div>
                                </Box>
                                : null
                              }
                            </Grid>
                          </Grid>
                          {/* end status box */}
                          {/* <Grid container mt={2}>
                          <Grid item xs sm md lg display="flex" alignItems="center">
                            <Box sx={{ mr: 1 }}><InfoIcon></InfoIcon></Box>
                            <Typography variant="label" sx={{ mr: 1 }}>
                              ขั้นตอนถัดไป:
                            </Typography>
                            <Typography variant="sub_label">ส่งขออนุมัติจัดทำข้อตกลงภาระงานทางวิชาการประจำปี</Typography>
                          </Grid>
                        </Grid> */}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={1}>
                    <Grid item lg={6} md={6} xs={12}>
                      <BarChartPlanning data={loRow?.planning} title={t("home.label.paPlanning")} callBack={callBackPath} path={loRow?.planning?.id !== undefined && loRow?.planning?.id !== null ? "/app/planning/" + loRow?.planning?.id : ""} />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                      <BarChartPlanning data={loRow?.Actual} title={t("home.label.paActual")} callBack={callBackPath} path={loRow?.Actual?.id !== undefined && loRow?.Actual?.id !== null ? "/app/planning/" + loRow?.Actual?.id : ""} />
                    </Grid>
                  </Grid>
                  <Grid sx={{ width: "100%", "padding-top": "30px", "padding-bottom": "30px" }}>
                    <Divider />
                  </Grid>
                </Box>
              ))
              :
              Object.keys(dataGoals).length > 0 ?
                <Box>
                  <Grid container item pb={2} pt={2}>
                    <Grid item xs sm md lg sx={{ height: 1 }}>
                      <Card sx={{ height: 1, overflow: "unset" }}>
                        <CardContent sx={{ px: 2 }} style={{ "padding-bottom": "20px" }}>
                          <Grid container spacing={0} justifyContent="space-between">
                            <Grid item sx={{ display: "flex", "align-items": "center" }}>
                              <div
                                className={`${classes.iconContainer}`}
                                style={{ background: "#5DA196" }}
                              >
                                <img src={overview} alt="bannerImage" />
                              </div>
                              <Typography
                                fontSize={20}
                                ml="15px"
                                lineHeight="22px"
                                sx={{ fontWeight: "600" }}
                              >
                                Overview & Achievements
                              </Typography>
                            </Grid>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <Box mt="4px">
                                {/* {data?.code === "y" ? */}
                                <BootstrapTooltip title={`View my achievements`} placement="top">
                                  <KpiArrow style={{ cursor: "pointer" }} />
                                </BootstrapTooltip>
                                {/* : null
                                } */}
                              </Box>
                            </Box>
                          </Grid>
                          <Grid sx={{ width: "100%", "padding-top": "20px" }}>
                            <Divider />
                          </Grid>
                          <Grid container spacing={4}>
                            <Grid item xs={12} display="flex">
                              <Grid item sx={{ "min-width": "450px", width: "35%" }} >
                                <GoalsStatus />
                              </Grid>
                              <Grid item sx={{ width: "65%" }}>
                                <MyAchievements />
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid container item pb={2} pt={2}>
                    <Grid item xs sm md lg sx={{ height: 1 }}>
                      <Card sx={{ height: 1, overflow: "unset" }}>
                        <CardContent sx={{ px: 2 }}>
                          <Grid container spacing={0} justifyContent="space-between">
                            <Grid item sx={{ display: "flex", "align-items": "center" }}>
                              <div
                                className={`${classes.iconContainer}`}
                                style={{ background: "#5DA196" }}
                              >
                                <img src={file} alt="bannerImage" />
                              </div>
                              <Box item>
                                <Typography
                                  fontSize={20}
                                  ml="15px"
                                  lineHeight="22px"
                                  sx={{ fontWeight: "600" }}
                                >
                                  Performance Evaluation Overview
                                </Typography>
                              </Box>
                            </Grid>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <Box mt="4px">
                                {/* {data?.code === "y" ? */}
                                <BootstrapTooltip title={`View my evaluation`} placement="top">
                                  <KpiArrow style={{ cursor: "pointer" }} />
                                </BootstrapTooltip>
                                {/* : null
                                } */}
                              </Box>
                            </Box>
                          </Grid>
                          <Grid sx={{ width: "100%", "padding-top": "23px" }}>
                            <Divider />
                          </Grid>
                          <Grid sx={{ width: "100%", "padding-top": "15px", display: "flex", alignItems: "center" }}>
                            <CalendarIcon /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px"> Performance evaluation period: August 2020-July 2021</Typography>
                          </Grid>
                          <Grid sx={{ width: "100%", "padding-top": "20px", "padding-bottom": "19px", display: "flex", alignItems: "center" }}>
                            <CalendarIcon /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px"> Sign-off due date: September 30, 2021</Typography>
                          </Grid>
                          <Grid container spacing={4}>
                            <Grid item xs={12} display="flex">
                              {dataGoals.rb_pa_data !== undefined && dataGoals?.rb_pa_data !== null ?
                                <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        dataGoals.rb_pa_data[0]?.status === "draft" ?
                                          "#F7B2541A"
                                          : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                            "#F280261A"
                                            : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                              "#5DA1961A"
                                              : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        dataGoals.rb_pa_data[0]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"

                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "start" }}
                                    >
                                      <Box
                                        mt="4px"
                                        style={{
                                          background:
                                            dataGoals.rb_pa_data[0]?.status === "draft" ?
                                              "#F9C47F"
                                              : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                                "#F28026"
                                                : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                  "#5DA196"
                                                  : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            dataGoals.rb_pa_data[0]?.status === "draft" ||
                                              dataGoals.rb_pa_data[0]?.status === "pending" ||
                                              dataGoals.rb_pa_data[0]?.status === "approved" ||
                                              dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                              dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                              dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                              dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* <CheckIcon></CheckIcon> */}
                                        {
                                          dataGoals.rb_pa_data[0]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : dataGoals.rb_pa_data[0]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : dataGoals.rb_pa_data[0]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : dataGoals.rb_pa_data[0]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : dataGoals.rb_pa_data[0]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : dataGoals.rb_pa_data[0]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : dataGoals.rb_pa_data[0]?.status === "cancel_cancel" || dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                        <Typography fontSize="18" fontWeight="600"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Goal and competency review and self-evaluation
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Status: {formatData(dataGoals.rb_pa_data[0]?.status_description, "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[0]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[0]?.status === "draft" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved" ||
                                                dataGoals.rb_pa_data[0]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[0]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[0]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[0]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <div style={{ width: "max-content" }}>
                                        <BootstrapTooltip
                                          style={{ width: "max-content" }}
                                          onClose={e => handleTooltipOpen("1")}
                                          open={open === true && valueSerial === "1" ? true : false}
                                          placement="top"
                                          arrow
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          title={`Give honest feedback on how you perceive your performance.`}
                                        >
                                          <InfoIcon style={{ cursor: "pointer" }} />
                                        </BootstrapTooltip>
                                        <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                      </div>
                                    </Box>
                                  </div>
                                  {/* connector */}
                                  <div
                                    style={{
                                      borderTop: "3px dashed #E5E5E5",
                                      width: "100%",
                                      maxWidth: "65px"
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        dataGoals.rb_pa_data[1]?.status === "draft" ?
                                          "#F7B2541A"
                                          : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                            "#F280261A"
                                            : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                              "#5DA1961A"
                                              : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        dataGoals.rb_pa_data[1]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"
                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "start" }}
                                    >
                                      <Box
                                        mt="4px"
                                        style={{
                                          background:
                                            dataGoals.rb_pa_data[1]?.status === "draft" ?
                                              "#F9C47F"
                                              : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                                "#F28026"
                                                : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                  "#5DA196"
                                                  : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            dataGoals.rb_pa_data[1]?.status === "draft" ||
                                              dataGoals.rb_pa_data[1]?.status === "pending" ||
                                              dataGoals.rb_pa_data[1]?.status === "approved" ||
                                              dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                              dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                              dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                              dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {
                                          dataGoals.rb_pa_data[1]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : dataGoals.rb_pa_data[1]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : dataGoals.rb_pa_data[1]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : dataGoals.rb_pa_data[1]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : dataGoals.rb_pa_data[1]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : dataGoals.rb_pa_data[1]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : dataGoals.rb_pa_data[1]?.status === "cancel_cancel" || dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                        <Typography fontSize="18" fontWeight="600"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Evaluator review the evaluation
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Status: {formatData(dataGoals.rb_pa_data[1]?.status_description, "ยังไม่ดำเนินการ")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[1]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[1]?.status === "draft" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved" ||
                                                dataGoals.rb_pa_data[1]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[1]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[1]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[1]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <div style={{ width: "max-content" }}>
                                        <BootstrapTooltip
                                          style={{ width: "max-content" }}
                                          onClose={e => handleTooltipOpen("2")}
                                          open={open === true && valueSerial === "2" ? true : false}
                                          placement="top"
                                          arrow
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          title={`Feedback the performance and how others perceive your performance.`}
                                        >
                                          <InfoIcon style={{ cursor: "pointer" }} />
                                        </BootstrapTooltip>
                                        <div className='tooltip' onClick={e => handleTooltipOpen("2")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                      </div>
                                    </Box>
                                  </div>
                                  {/* connector */}
                                  <div
                                    style={{
                                      borderTop: "3px dashed #E5E5E5",
                                      width: "100%",
                                      maxWidth: "65px"
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        dataGoals.rb_pa_data[2]?.status === "draft" ?
                                          "#F7B2541A"
                                          : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                            "#F280261A"
                                            : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                              "#5DA1961A"
                                              : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        dataGoals.rb_pa_data[2]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"
                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "start" }}
                                    >
                                      <Box
                                        mt="4px"
                                        style={{
                                          background:
                                            dataGoals.rb_pa_data[2]?.status === "draft" ?
                                              "#F9C47F"
                                              : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                                "#F28026"
                                                : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                  "#5DA196"
                                                  : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            dataGoals.rb_pa_data[2]?.status === "draft" ||
                                              dataGoals.rb_pa_data[2]?.status === "pending" ||
                                              dataGoals.rb_pa_data[2]?.status === "approved" ||
                                              dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                              dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                              dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                              dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                              dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {
                                          dataGoals.rb_pa_data[2]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : dataGoals.rb_pa_data[2]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : dataGoals.rb_pa_data[2]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : dataGoals.rb_pa_data[2]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : dataGoals.rb_pa_data[2]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : dataGoals.rb_pa_data[2]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : dataGoals.rb_pa_data[2]?.status === "cancel_cancel" || dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                        <Typography
                                          fontSize="18"
                                          fontWeight="600"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Evaluation review and 1-on-1 session
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Status: {formatData(dataGoals.rb_pa_data[2]?.status_description, "ยังไม่ดำเนินการ")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        pb: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[2]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[2]?.status === "draft" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved" ||
                                                dataGoals.rb_pa_data[2]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[2]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[2]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[2]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <div style={{ width: "max-content" }}>
                                        <BootstrapTooltip
                                          style={{ width: "max-content" }}
                                          onClose={e => handleTooltipOpen("3")}
                                          open={open === true && valueSerial === "3" ? true : false}
                                          placement="top"
                                          arrow
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          title={`Evaluate that individual's overall performance, identify their strengths and weaknesses, offer feedback, and help them set goals.`}
                                        >
                                          <InfoIcon style={{ cursor: "pointer" }} />
                                        </BootstrapTooltip>
                                        <div className='tooltip' onClick={e => handleTooltipOpen("3")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                      </div>
                                    </Box>
                                  </div>
                                  {/* connector */}
                                  <div
                                    style={{
                                      borderTop: "3px dashed #E5E5E5",
                                      width: "100%",
                                      maxWidth: "65px"
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      maxWidth: "380px",
                                      width: "100%",
                                      height: "100%",
                                      background:
                                        dataGoals.rb_pa_data[3]?.status === "draft" ?
                                          "#F7B2541A"
                                          : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                            "#F280261A"
                                            : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                              "#5DA1961A"
                                              : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                "#CC60581A"
                                                : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                  "#CC60581A"
                                                  : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                    "#F280261A"
                                                    : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                      "#8282821A" : "#FFFFFF",
                                      border:
                                        dataGoals.rb_pa_data[3]?.status === "draft" ?
                                          "1px solid #F9C47F"
                                          : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                            "1px solid #F28026"
                                            : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                              "1px solid #5DA196"
                                              : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                "1px solid #CC6058"
                                                : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                  "1px solid #CC6058"
                                                  : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                    "1px solid #F28026"
                                                    : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                      "1px solid #828282" : "1px solid #DADADA",
                                      borderRadius: "5px",
                                      position: "relative",
                                      paddingBottom: "25px"
                                    }}
                                  >
                                    <Box
                                      sx={{ p: 1, display: "flex", alignItems: "start" }}
                                    >
                                      <Box
                                        mt="4px"
                                        style={{
                                          background:
                                            dataGoals.rb_pa_data[3]?.status === "draft" ?
                                              "#F9C47F"
                                              : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                                "#F28026"
                                                : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                  "#5DA196"
                                                  : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                    "#CC6058"
                                                    : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                      "#CC6058"
                                                      : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                        "#F28026"
                                                        : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                          "#828282" : "#FAFAFA",
                                          border:
                                            dataGoals.rb_pa_data[3]?.status === "draft" ||
                                              dataGoals.rb_pa_data[3]?.status === "pending" ||
                                              dataGoals.rb_pa_data[3]?.status === "approved" ||
                                              dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                              dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                              dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                              dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                              dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                              "none" : "1px dashed #C4C4C4",
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                        }}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {
                                          dataGoals.rb_pa_data[3]?.status === "draft" ?
                                            <DraftIcon></DraftIcon>
                                            : dataGoals.rb_pa_data[3]?.status === "pending" ?
                                              <PendingIcon></PendingIcon>
                                              : dataGoals.rb_pa_data[3]?.status === "approved" ?
                                                <ApprovedIcon></ApprovedIcon>
                                                : dataGoals.rb_pa_data[3]?.status === "approved_cancel" ?
                                                  <CancelIcon1></CancelIcon1>
                                                  : dataGoals.rb_pa_data[3]?.status === "rejected" ?
                                                    <RejectIcon></RejectIcon>
                                                    : dataGoals.rb_pa_data[3]?.status === "pending_cancel" ?
                                                      <PendingIcon></PendingIcon>
                                                      : dataGoals.rb_pa_data[3]?.status === "cancel_cancel" || dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                        <CancelIcon1></CancelIcon1>
                                                        : null
                                        }
                                      </Box>
                                      <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                        <Typography
                                          fontSize="18"
                                          fontWeight="600"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Employee and Evaluator sign off
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Status: {formatData(dataGoals.rb_pa_data[3]?.status_description, "ยังไม่ดำเนินการ")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}
                                        >
                                          Submitted date: {formatData(dateDayFormat(dataGoals.rb_pa_data[3]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          width: "30px",
                                        }}
                                      ></Box>
                                      <Box sx={{ ml: 2 }}>
                                        <Typography variant="h6" fontWeight="400"
                                          sx={{
                                            color:
                                              dataGoals.rb_pa_data[3]?.status === "draft" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved" ||
                                                dataGoals.rb_pa_data[3]?.status === "approved_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "rejected" ||
                                                dataGoals.rb_pa_data[3]?.status === "pending_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel_cancel" ||
                                                dataGoals.rb_pa_data[3]?.status === "cancel" ?
                                                "#404349"
                                                : "#C4C4C4"
                                          }}>
                                          Due date: {formatData(dateDayFormat(dataGoals.rb_pa_data[3]?.submitted_date), "-")}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Box
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        margin: 6,
                                      }}
                                    >
                                      <div style={{ width: "max-content" }}>
                                        <BootstrapTooltip
                                          style={{ width: "max-content" }}
                                          onClose={e => handleTooltipOpen("4")}
                                          open={open === true && valueSerial === "4" ? true : false}
                                          placement="top"
                                          arrow
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          title={`Acknowledgement that the performance evaluation review and discussion between you and your manager have been held.`}
                                        >
                                          <InfoIcon style={{ cursor: "pointer" }} />
                                        </BootstrapTooltip>
                                        <div className='tooltip' onClick={e => handleTooltipOpen("4")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                      </div>
                                    </Box>
                                  </div>
                                </Box>
                                : null
                              }
                            </Grid>
                            {dataGoals.rb_pa_data !== undefined && dataGoals?.rb_pa_data !== null ?
                              <Grid item xs={12} display="flex" pt="15px !important" sx={{ "svg": { width: "18px", height: "18px" } }}>
                                <InfoIcon />
                                <Typography ml="12px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "400" }} >Next action: </Typography>
                                <Typography ml="5px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "300" }} >Review the evaluation results with your assigned manager in 1-on1 session</Typography>
                              </Grid>
                              : null
                            }
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={1}>
                    <Grid item lg={6} md={6} xs={12}>
                      <DashboardMyGoals icon={myGoals} title="My Goal" data={dataGoals.myGoals} />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                      <DashboardMyCompetencies icon={myCompetencies} title="My Competencies" data={dataGoals.myCompetencies} />
                    </Grid>
                  </Grid>
                  <Grid sx={{ width: "100%", "padding-top": "30px", "padding-bottom": "30px" }}>
                    <Divider />
                  </Grid>
                </Box >
                : null
          }
          <Inbox />
        </Container >
      </Box >
    </>
  );
};
export default Home;
